import api from '../utils/api';

const BUSINESS_ID = process.env.REACT_APP_BUSINESS_ID;

export const getServices = (params) => {
  return api.get(`/businesses/${BUSINESS_ID}/services`, { params });
};

export const getServiceDetail = (serviceId) => {
  return api.get(`/businesses/${BUSINESS_ID}/services/${serviceId}`);
};

export const getCategories = () => {
  return api.get(`/businesses/${BUSINESS_ID}/categories`);
};

export const getCategoryWithServices = (categoryId) => {
  return api.get(`/businesses/${BUSINESS_ID}/categories/${categoryId}`);
};
